import { appConfigurationApi } from './api';
import {
  APP_CONFIGURATION_REQUEST,
  APP_CONFIGURATION_SUCCESS,
  APP_CONFIGURATION_FAILURE,
  APP_CONFIGURATION_SET_USER_CONFIGURATION,
} from './constants';

const getConfiguration = () => async (dispatch, getState) => {
  const { provider, authentication: { user } } = getState();
  const { user_wix_id: userWixId } = user ?? {};
  dispatch({ type: APP_CONFIGURATION_REQUEST });
  try {
    const configuration = await appConfigurationApi.getConfiguration({ provider, userWixId });
    dispatch({
      type: APP_CONFIGURATION_SUCCESS,
      payload: { ...configuration, userWixId, provider },
    });
  } catch (ex) {
    console.error('Error occurred, while getting app configuration:', ex);
    dispatch({ type: APP_CONFIGURATION_FAILURE });
  }
};

const updateUserConfiguration = (userConfigurationToUpdate) => async (dispatch, getState) => {
  const { authentication: { user } } = getState();
  const { user_wix_id: userWixId } = user ?? {};
  try {
    const userConfiguration = await appConfigurationApi.updateUserConfiguration({ userWixId, data: userConfigurationToUpdate });
    dispatch({ type: APP_CONFIGURATION_SET_USER_CONFIGURATION, payload: userConfiguration });
  } catch (ex) {
    console.error('Error occurred, while setting app configuration data:', ex);
  }
};

const setIsIntakeOnboardingShown = () => async (dispatch, getState) => {
  const {
    appConfiguration: { userConfiguration: { isIntakeOnboardingShown } = {} },
    authentication: { user },
  } = getState();
  const { user_wix_id: userWixId } = user ?? {};
  if (isIntakeOnboardingShown || !userWixId) {
    return;
  }
  dispatch(updateUserConfiguration({ isIntakeOnboardingShown: true }));
};

export const appConfigurationActions = {
  getConfiguration,
  updateUserConfiguration,
  setIsIntakeOnboardingShown,
};
